import React, { useMemo } from 'react';
import { useTranslation } from 'utils/i18n';
import LegalLayout from 'components/legal/LegalLayout';
import { mapLegacyDpaToSections } from 'utils/legal/sections';

const DataProcessingAgreement = () => {
  const { t, language } = useTranslation();
  
  // Re-compute sections when language changes
  const sections = useMemo(() => mapLegacyDpaToSections(t), [language]);
  const title = t('title', 'dpa') || 'Data Processing Agreement';
  const lastUpdated = t('lastUpdated', 'dpa') || '';

  return <LegalLayout title={title} lastUpdated={lastUpdated} sections={sections} />;
};

export default DataProcessingAgreement;
